var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('Navigation',{attrs:{"isFixedNavBar":this.fixedNav}}),_c('About'),_c('Consultation',{ref:"consultationRef"}),_c('Faq'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }